import { Typography } from '@mui/material';
import { FC } from 'react';
import { TooltipComponent } from './TooltipComponent';

interface TooltipCellProps {
  value: string | number;
  lineClamp?: number;
}

export const TooltipCell: FC<TooltipCellProps> = ({ value, lineClamp = 5 }) => {
  return (
    <TooltipComponent tooltipTitle={value} lineClamp={lineClamp}>
      <Typography variant="body2">{value}</Typography>
    </TooltipComponent>
  );
};
